import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { UpdateAnalyticsSearchParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListAnalyticsSearches } from "../queries/useListAnalyticsSearches";

export const UpdateAnalyticsSearch = graphql(/* GraphQL */ `
	mutation UpdateAnalyticsSearch($params: UpdateAnalyticsSearchParams!) {
		updateAnalyticsSearch(params: $params) {
			success
			error {
				code
				message
			}
		}
	}
`);

export function useUpdateAnalyticsSearch() {
	const [updateAnalyticsSearch] = useMutation(UpdateAnalyticsSearch, {
		refetchQueries: [ListAnalyticsSearches],
	});

	const handleUpdateAnalyticsSearch = useCallback(
		async (params: UpdateAnalyticsSearchParams) => {
			const result = await updateAnalyticsSearch({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.updateAnalyticsSearch.success,
				error: result.data?.updateAnalyticsSearch.error,
			};
		},
		[updateAnalyticsSearch]
	);

	return { handleUpdateAnalyticsSearch };
}
